import { FC } from 'react';
import { Section } from './ui/Section';
import type { Interest } from '../types/cv';

interface Props {
  interests: Interest[];
  title?: string;
}

export const Interests: FC<Props> = ({ interests, title = 'Interests' }) => (
  <Section title={title}>
    {interests.map((interest, i) => (
      <div className="cv-entry" key={`${interest.name}-${i}`}>
        {interest.name && <h3 className="cv-skill-name">{interest.name}</h3>}
        {interest.keywords?.map((keyword, k) => (
          <p key={k} className={k === 0 && !interest.name ? undefined : 'cv-note'}>
            {keyword}
          </p>
        ))}
      </div>
    ))}
  </Section>
);

export default Interests;
